import { render, staticRenderFns } from "./CourseProgressesProtocol.vue?vue&type=template&id=127ae441"
import script from "./CourseProgressesProtocol.vue?vue&type=script&lang=js"
export * from "./CourseProgressesProtocol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports